export function show_modal_birthday(state = true, action) {
  if (action.type === 'SHOW_MODAL_BIRTHDAY') {
    return true;
  }
  if (action.type === 'HIDE_MODAL_BIRTHDAY') {
    return false;
  }
  return state;
}
